import React from 'react'
import { useRouteMatch } from 'react-router-dom'
import { useApiListAnalyticType } from '../../../../api-new/state/analytics'
import { Menu, MenuAdd, MenuDelete, MenuEdit, MenuRecycle } from '../../../../shared/menu/menu'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { IconList } from '../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { TableAgClient } from '../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../shared/table-builder/table-columns'

export const AnalyticTypeList = () => {
  const { url } = useRouteMatch()

  const apiListAnalyticType = useApiListAnalyticType()

  const handleReady = () => apiListAnalyticType.get()
  const handleDestroyed = () => apiListAnalyticType.init()

  const handleDelete = async data => {
    await apiListAnalyticType.delete(data.id)
    await apiListAnalyticType.get()
  }

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd to={`${url}/add`} show />
      <MenuRecycle to={`${url}/recycle`} show />
    </Menu>

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Analytic types">
        <CardFullHeightScrollY title="Analytic types" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListAnalyticType} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="name" />
            <ColumnText field="description" />
            <ColumnText field="analyticCount" header="Analytics" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuEdit to={`${url}/${row.id}/edit`} show />
                  <MenuDelete onClick={() => handleDelete(row)} show />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
